import JSZip from 'jszip';
import { debug } from './debug';
/**
 * Unzip all files in zip archive and return a map with the filename as a key and the file content as a value
 * @param data
 */
export function unzipFiles(data) {
    const zip = new JSZip();
    const files = [];
    return zip
        .loadAsync(data)
        .then(function (contents) {
        Object.keys(contents.files).forEach(function (filename) {
            const zipFile = zip.file(filename);
            if (zipFile) {
                files.push(zipFile
                    .async('nodebuffer')
                    .then((fileData) => {
                    return {
                        filename,
                        data: fileData,
                    };
                })
                    .catch((err) => {
                    debug(`Error unzipping file ${filename}: ${err.message}`, err);
                    return {
                        filename,
                        data: undefined,
                    };
                }));
            }
            else {
                debug(`Skip file ${filename} as it does to exist`);
            }
        });
        return Promise.all(files);
    })
        .then((loadedFiles) => {
        const obs = {};
        for (const file of loadedFiles) {
            obs[file.filename] = file.data;
        }
        return obs;
    });
}
/**
 * Zip utility class
 * Can extract files from a zip archive
 * Or build a zip archive by adding files
 *
 */
export class Zip {
    constructor(zip = new JSZip()) {
        this.zip = zip;
    }
    /**
     * Create a new Zip utility instance
     */
    static createNew() {
        return new Zip();
    }
    /**
     * Ceate Zip instance from zip data buffer
     * @param data
     */
    static async loadZip(data) {
        const zip = new JSZip();
        await zip.loadAsync(data);
        return new Zip(zip);
    }
    /**
     * Add file to Zip
     * @param filename file name
     * @param content file content
     */
    putFile(filename, content) {
        this.zip.file(filename, content);
        return this;
    }
    /**
     * Generate zip
     */
    generate() {
        return this.zip.generateAsync({
            type: 'uint8array',
        });
    }
    /**
     *
     * @param name
     */
    hasFile(name) {
        return !!this.zip.file(name);
    }
    /**
     * Extract file by name from current zip
     * @param name file name
     * @param encoding file encoding
     *
     * @throws if file does not exist
     */
    async getFile(name, encoding) {
        const zipFile = this.zip.file(name);
        if (zipFile) {
            return await zipFile.async(encoding);
        }
        throw new Error(`File "${name}" not found in Zip`);
    }
    getFilesMeta() {
        return Object.values(this.zip['files']);
    }
    /**
     * @deprecated use `getFile()` instead. Will be removed in v2.0.0 and above
     */
    async file(name, encoding) {
        return this.getFile(name, encoding);
    }
}
